module.exports = __webpack_public_path__ + "img/missionaries19_2019_7-7-2021.4c95042e.jpg";